import React from 'react'
import { RefreshCw } from 'lucide-react'
import { buttonVariants, buttonDisabledStyle } from "../../styles/buttonStyles";
import { useTranslation } from "react-i18next";

interface RestartButtonProps {
  onRestart: () => void
  iconSize?: number
  disabled?: boolean
  children?: React.ReactNode
}

const RestartButton: React.FC<RestartButtonProps> = ({
  onRestart,
  iconSize: _iconSize = 24,
  disabled = false,
  children
}) => {
  const { t } = useTranslation('common');
  return (
    <button
      type="button"
      onClick={onRestart}
      disabled={disabled}
      className={`${buttonVariants.restart} ${disabled ? buttonDisabledStyle : ''}`}
    >
      <RefreshCw className="w-4 h-4 sm:w-5 sm:h-5 mr-1.5 sm:mr-2 flex-shrink-0" />
      <span className="truncate">{children || t('common.restart')}</span>
    </button>
  )
}

export default RestartButton
